<template>
  <div class="m-0 dbozone-font bg-vampire" :class="`${lang}-font`">
    <div class="container d-flex flex-column justify-content-center">
      <div class="d-flex flex-column nav-vampire">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title">
            {{ $t("vampire.name") }}
          </h5>
        </section>
      </div>
      <div class="d-flex p-2 mt-1" v-for="(text, index) in textList" :key="index" >
        <div v-if="index===1">
          <div v-if="lang==='zh'" class="">
            <span class="m-0 text-sub" :class="`-${lang}`">
              {{ $t(`${text}_1`) + baseBet + $t(`${text}_2`) + betLevel[0] + $t('info.to') + betLevel[betLevel.length-1] + $t(`${text}_3`) + betSize[0] + $t('info.to') + betSize[betSize.length-1] }}
            </span>
          </div>
          <div v-else class="">
            <span class="m-0 text-sub" :class="`-${lang}`">
              {{ $t(`${text}_1`) + baseBet + $t(`${text}_2`) + betLevel[0] + $t('info.to') + betLevel[betLevel.length-1] + $t(`${text}_3`) + betSize[0] + $t('info.to') + betSize[betSize.length-1] }}
            </span>
          </div>
        </div>
        <div v-else>
          <span class="m-0 text-sub" :class="`-${lang}`">{{ $t(text) }}</span>
        </div>
      </div>

      <div class="d-flex flex-column nav-vampire">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title" :class="`-${lang}`">{{ $t('featurebuy.title') }}</h5>
        </section>
      </div>
       <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('featurebuy.text1') }}</span>
      </div>
      <div class="d-flex p-2 mt-1">
        <span class=" m-0 text-sub" :class="`-${lang}`">{{ $t('featurebuy.text2') }}</span>
      </div>

      <div class="d-flex flex-column nav-vampire">
        <section class="d-flex p-2">
          <h5 class="font-weight-bold m-0 text-title">
            {{ $t("main-game.title") }}
          </h5>
        </section>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img
          class="mt-3 iconSmall-info-vampire"
          :src="require(`../../assets/ruleGames/main/wallet_icon.png`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.wallet-balance")
        }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.text-wallet")
        }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img
          class="mt-3 iconSmall-info-vampire"
          :src="require(`../../assets/ruleGames/vampire/bet_amount_icon.png`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.bet-amount") }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.text-bet1") }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.text-bet2") }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.text-bet3") }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img
          class="mt-3 iconSmall-info-vampire"
          :src="require(`../../assets/ruleGames/vampire/win_icon.png`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.win-amount") }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.text-win-amount")
        }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img
          class="mt-3 icon-info-vampire"
          :src="require(`../../assets/ruleGames/vampire/spin_btn.png`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.spin") }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.text-spin1") }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.text-spin2") }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.text-spin3") }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.text-spin4") }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img
          class="mt-3 icon-info-vampire"
          :src="require(`../../assets/ruleGames/vampire/stop_btn.png`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.stop") }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.text-stop") }}</span>
      </div>
      <div class="d-flex p-2 justify-content-center">
        <img
          class="mt-3 icon-info-vampire"
          :src="require(`../../assets/ruleGames/vampire/minus_btn.png`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.minus") }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.text-minus") }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img
          class="mt-3 icon-info-vampire"
          :src="require(`../../assets/ruleGames/vampire/plus_btn.png`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.plus") }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.text-plus") }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img
          class="mt-3 icon-info-vampire"
          :src="require(`../../assets/ruleGames/vampire/auto_spin_btn.png`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.autospin") }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.text-auto1") }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.text-auto2") }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img
          class="mt-3 iconSmall-info-vampire"
          :src="require(`../../assets/ruleGames/vampire/menu_btn.png`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.menu") }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.text-menu") }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img
          class="mt-3 iconSmall-info-vampire"
          :src="require(`../../assets/ruleGames/vampire/turbo_on.svg`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.turbo") }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.text-turbo") }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img
          class="mt-3 iconSmall-info-vampire"
          :src="require(`../../assets/ruleGames/vampire/turbo_off.svg`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.normal-turbo")
        }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.text-normal-turbo")
        }}</span>
      </div>
      <div class="d-flex p-2 mt-1 justify-content-center">
        <img
          class="mt-3 icon-info-vampire"
          :src="require(`../../assets/ruleGames/vampire/quit_icon.svg`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.quit") }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.text-quit") }}</span>
      </div>
      <div class="d-flex p-2 justify-content-center">
        <img
          class="mt-3 icon-info-vampire"
          :src="require(`../../assets/ruleGames/vampire/info_icon.svg`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.pay-info") }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.text-info") }}</span>
      </div>
      <div class="d-flex p-2 justify-content-center">
        <img
          class="mt-3 icon-info-vampire"
          :src="require(`../../assets/ruleGames/vampire/paytable_icon.svg`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.info-paytable")
        }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.text-paytable")
        }}</span>
      </div>
      <div class="d-flex p-2 justify-content-center">
        <img
          class="mt-3 icon-info-vampire"
          :src="require(`../../assets/ruleGames/vampire/history_icon.svg`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.history") }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.text-history")
        }}</span>
      </div>
      <div class="d-flex p-2 justify-content-center">
        <img
          class="mt-3 icon-info-vampire"
          :src="require(`../../assets/ruleGames/vampire/option_icon.svg`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.setting") }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{
          $t("main-game.text-setting")
        }}</span>
      </div>
      <div class="d-flex p-2 justify-content-center">
        <img
          class="mt-3 icon-info-vampire"
          :src="require(`../../assets/ruleGames/vampire/close_icon.svg`)"
          alt=""
        />
      </div>
      <div class="d-flex p-2 justify-content-center">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.close") }}</span>
      </div>
      <div class="d-flex p-2">
        <span class="m-0 text-sub" :class="`-${lang}`">{{ $t("main-game.text-close") }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'rule-vampire',
  props: {
    data: Object,
    lang: String,
  },
  data() {
    return {
      textList: [
        'vampire.text-rule1',
        '4_5_base.text-rule2',
        '4_5_base.text-rule3',
        '4_5_base.text-rule4',
        '4_5_base.text-rule5',
        '4_5_base.text-rule6',
        '4_5_base.text-rule7',
        '4_5_base.text-rule8',
        '4_5_base.text-rule9',
        '4_5_base.text-rule10',
        '4_5_base.text-rule11',
        '4_5_base.text-rule12',
        '4_5_base.text-rule13',
        '4_5_base.text-rule14',
        '4_5_base.text-rule15',
        '4_5_base.text-rule16',
      ],
      baseBet: this.data.config.baseBet,
      betLevel: this.data.config.betLevel,
      betSize: this.data.config.betSize,
    };
  },
};
</script>

<style>

.icon-info-vampire {
  width: 20%;
  height: 100%;
}

.iconSmall-info-vampire {
  width: 20%;
  height: 120%;
}

.bg-vampire {
  background: #330000;
}
</style>